const discardItemsWithEmptyValues = obj =>
  Object.keys(obj).reduce((acc, key) => {
    const value = obj[key];
    if (value && value !== '') {
      return { ...acc, [key]: value };
    }
    return acc;
  }, {});

// eslint-disable-next-line
export { discardItemsWithEmptyValues };



// WEBPACK FOOTER //
// ./src/helpers/object.js